import loginService from '../login.service';
import repository from '../../repositories/crm/crm.agenda.repository';

import {
    ORBITA_CONNECTION_ROLE,
    ORBITA_DISCONNECTED_CODE,
    ORBITA_DISCONNECTED_STATUS
} from '../../constant/crm/crm.orbita.connection.constant';

const isRequired = () => loginService.isLogin() && loginService.isValidRoles([ORBITA_CONNECTION_ROLE]);

const isDisconnectedError = (error) =>
    error?.status === ORBITA_DISCONNECTED_STATUS &&
    error?.response?.data?.code === ORBITA_DISCONNECTED_CODE;

// Falha na leitura não trava a tela: a API bloqueia as ações de qualquer forma.
const findState = async () => {
    try {
        const response = await repository.findOrbitaConnection();
        return { blocked: response?.data?.blocked === true };
    } catch (error) {
        return { blocked: isDisconnectedError(error) };
    }
};

export default {
    isRequired,
    findState
};
